'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        label: '',
        list: [],
        name: '',
        selectedVal: '',
        tabIndex: ''
    },

    watch: {
        selectedVal: function selectedVal() {
            this.$dispatch('update', this.selectedVal);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "<div class=drop-down><select class=drop-down__select id=\"{{ name }}\" name=\"{{ name }}\" v-model=selectedVal tabindex=\"{{ tabIndex }}\"><option v-for=\"(item, value) in list\" value=\"{{ item }}\">{{ (typeof value == 'object') ? value.name : value }}</select><label class=drop-down__label for=\"{{ name }}\">{{ label}}</label></div>"
